import React, {useEffect, useState} from 'react';
import { CreateLeadFooter,  StyledGridContainer, StyledSubHeader } from '../../Components/Styled';
import { Box, Button, createFilterOptions, Stack, Typography } from '@mui/material';
import { privateRoutesPath } from '../../Routes';
import BiztantuLoader from '../../Components/Loader';
import { useSelector, useDispatch } from 'react-redux';
import { createOrderRequestData,  getOrderRequestData } from '../../Utility/apiHelper';
import { ACTIVE_STATUS, handleValidateCodevalue, INVOICE_STATUS, PRODUCT_TYPE, searchEntity } from '../../Utility/constant';
import { useSnackbar } from 'notistack';
import { requestHideLoader, requestShowLoader } from '../../Store/Global/action';
import { EntityNote } from '../../Components/EntityNote';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import LeadProduct from '../../Components/LeadProduct';
import TextFiledWithLabel from '../../Components/TextFieldWithLabel';
import SelectBoxWithLabel from '../../Components/SelectBoxWithLable';
import AutoCompleteComponent from '../../Components/AutoCompleteComponenet';
import { requestGetAllCustomers } from '../../Store/Customer/action';
import useNavigation from '../../Utility/hooks/useNavigation';
import './invoice.css';


const CreateInvoice = () => {
    const [isRequired,setIsRequired] = useState(false);
    const [isDialogOpen, setOpenDialog] = useState({
            isOpen: false,
            dilaogproductdata: []
    });
    const [selectionModel, setSelectionModel] = React.useState([]);
    var filterdOptionlist = [];
    const [inputprice, setInputprice] = useState({
        pricefromInput: 0,
        pricetoInput: 100000000
    })
    const [tableData, setTableData] = useState([]);
    const [selectedaddedproduct, setselectedaddedproduct] = useState([]);
    const [selectedproduct, setSelectedproduct] = useState(null);
    const [selectedproductData, setSelectedProductData] = useState(null);
    const location = useLocation()
   const [isViewMode,setIsViewMode] = useState(location?.state?.isViewMode);
    const isLoadingProgress = useSelector(state => state?.global.isLoading);
    const currentUser = useSelector(state => state?.owner?.currentuser);
    const [invoicedetail, setinvoicedetail] = useState({
      status : 'INVOICE_STATUS_OPEN',
      ownerId : currentUser?.userId
    });
    const [invoiceProducts , setInvoiceProducts] = useState([]);
    const [initialInvoiceDetails,setInitialInvoiceDetails] = useState();
    const dispatch = useDispatch();
    const {enqueueSnackbar} = useSnackbar();
    const productStaticType = useSelector(state => state?.lookup?.lookupData)?.find((item) => item?.name == PRODUCT_TYPE)?.codes?.filter(item => item?.status == ACTIVE_STATUS)?.sort((a,b) => a?.sequence - b?.sequence);
    const invoiceStatusData = useSelector(state => state?.lookup?.lookupData)?.find((item) => item?.name == INVOICE_STATUS)?.codes?.filter(item => item?.status == ACTIVE_STATUS)?.sort((a,b) => a?.sequence - b?.sequence);  
    const [productQuantity, setproductQuantity] = useState(null);
    const internationalise = useSelector(state => state?.internationalise?.currentHashMapData)
    const ownerlist = useSelector(state => state?.owner?.ownerlist);  
    const specificRolePermission = useSelector(state => state?.owner?.rolebasedData);
    const [ownerlistdropdown, setownerlistdropdown] = useState([]);
    const myTeam = useSelector(state => state?.owner?.Team);
    const { navigateTo,goBackTo } = useNavigation();

            useEffect(() => {
                const ownerlistdata = ((specificRolePermission?.isAllInvoiceManage ? ownerlist : 
                specificRolePermission?.isInvoiceTeamManage ? myTeam : [{
                    firstName: `${currentUser?.firstname}`,
                    lastName : `${currentUser?.lastname}`,
                    id: currentUser?.userId,
                }]) || [])?.map(item => {
                    return {
                        name: `${item?.firstName} ${item?.lastName}`,
                        id: item?.id
                    }
                })
        
                setownerlistdropdown(ownerlistdata);
            },[ownerlist,myTeam,currentUser])
            useEffect(()=>{            
                const filteredOwner = ownerlistdropdown?.find(item=> item?.id ===  currentUser?.userId)
                    setinvoicedetail({
                        ...invoicedetail,
                        selectedOwner : filteredOwner,
                        ownerId : filteredOwner?.id
                })
            },[ownerlistdropdown])
            useEffect(()=>{
                dispatch(requestGetAllCustomers());
            },[])
    const customerdropdown = useSelector(state => state?.customer?.customer)
    
    const handlegenerateinvoice = () => {
        const dilaogproduct = invoiceProducts.filter(item => selectionModel.includes(item?.id)).map(item => {
            return {
                ...item,
                price : item?.sellingPrice,
                invoiceqty: item?.remainingQty
            }
        });
        setOpenDialog({
            ...isDialogOpen,
            isOpen: true,
            dilaogproductdata: dilaogproduct
        })
    }
    
    const handleCreateInvoice = async ()=>{
      if(invoicedetail?.ownerId && invoicedetail?.customerId){
      dispatch(requestShowLoader());
      const reqPayload = {
        ...invoicedetail,
        "invoiceProductDto" : []
      }
        tableData.map((item, index) => {
                reqPayload.invoiceProductDto.push({
                    ...item,
                    
                    "productId": item?.id,
                    "invoiceQty": parseFloat(item?.quantity),
                    "totalPrice" : item?.grossprice
                })
            });
        const url = `${process.env.REACT_APP_ORDER_URL}invoice`;
        const responseData = await createOrderRequestData(reqPayload,url);
        if(responseData?.status == 200){
          dispatch(requestHideLoader())
          enqueueSnackbar(handleValidateCodevalue(internationalise,'COMMON_CREATED_SUCCESSFULLY') , {variant : 'success'})
          navigateTo(`${privateRoutesPath.EDIT_INVOICE}/${responseData?.data?.id}`,{},searchEntity?.invoice)
        }
        else {
          dispatch(requestHideLoader())
          enqueueSnackbar(handleValidateCodevalue(internationalise,'COMMON_PLEASE_TRY_AGAIN'),{variant : 'error'})
        }
      dispatch(requestHideLoader())
      }
    else {
      
      dispatch(requestHideLoader())
      enqueueSnackbar(handleValidateCodevalue(internationalise,'COMMON_MSG_MANDATORY_FIELDS'),{variant:'error'})
      setIsRequired(true)
    }
    }
      
    const handleviewproductinvoices = (productId, orderId) => {
        navigateTo(`${privateRoutesPath.INVOICE}`,{productId, orderId },searchEntity?.invoice);
    }
    

        const handleChangeQuantity = (e) => {
            setproductQuantity(e.target.value)
        }
        
        const filter = createFilterOptions();
        const handleFilterOption = (options, params) => {
        filterdOptionlist = filter(options, params);
        return [ { name: 'Select All', price: "", value: "select-all" }, ...filterdOptionlist];
   }

     const handleAddOrderProduct = async() => {
         const payload = [];
 
         const productorderUrl = `${process.env.REACT_APP_ORDER_URL}sales-order-product`;
 
         selectedaddedproduct.map((item, index) => {
             payload.push({
                 "rate": parseFloat(item?.price),
                 "totalPrice": (1*item?.price),
                 "productId": item?.id,
                 "orderQty": 1,
             })
         });
 
         dispatch(requestShowLoader());
         
 
             const orderproductresponse = await createOrderRequestData(payload, productorderUrl);
 
 
             dispatch(requestHideLoader());
         
 
             enqueueSnackbar(handleValidateCodevalue(internationalise,'COMMON_ADDED_SUCCESSFULLY'), {variant: 'success'});
             
             await handlegetspecificinvoicedetails();
         // enqueueSnackbar('development is going on.', {variant: 'info'});
 
 
     }
   
  const handleUpdateOrderproduct = async(orderproduct) => {
        const payload = {
            ...orderproduct,
            "id": orderproduct?.id,
            "orderId": orderproduct?.orderId,
            "productId": orderproduct?.productId,
            "orderQty": orderproduct?.quantity,
            "productQuantity": parseFloat(orderproduct?.quantity),
            "rate": orderproduct?.rate,
        }
  const handleFilterOption = (options, params) => {
        filterdOptionlist = filter(options, params);
        return [ { name: 'Select All', price: "", value: "select-all" }, ...filterdOptionlist];
   }
  }

    const handleSelectMultiproduct = (event, productData, reason) => {
            if (productData.find(option => option.value === "select-all")) {
                setselectedaddedproduct([...selectedaddedproduct,...filterdOptionlist]);
            } else {
                setselectedaddedproduct(productData);
            }
        }


    const handleChangeInvoiceDetails = (event) => {
        setinvoicedetail({
            ...invoicedetail,
            [event.target.name]: event.target.value
        })
    }

    const handlegetspecificinvoicedetails = async() => {
        const url = `${process.env.REACT_APP_ORDER_URL}invoice/`;
        const responsedata = await getOrderRequestData(url);
        const productData = responsedata?.data;
        setinvoicedetail(productData);
        const invoiceProducts = productData.invoiceProductDto?.map(item => ({
        ...item,
        productId : item?.productId,
        id : item?.productId,
        type : item?.productType,
        name : item?.productName,
        }));
        setInvoiceProducts(invoiceProducts)
        setInitialInvoiceDetails({
            customerId : productData?.customerId,

        })
        dispatch(requestHideLoader());
        
    }

    const handleClearAfterAdded = () => {
        setselectedaddedproduct([]);
         
    }

    const handleSelectOwner=(event, Owner)=>{
        setinvoicedetail({
            ...invoicedetail,
            selectedOwner : Owner,
            ownerId : Owner?.id
        })
    }
    const handleSelectCustomer=(event, Customer)=>{
        setinvoicedetail({
            ...invoicedetail,
            selectedCustomer : Customer,
            customerId : Customer?.id
        })
    }

    const goBack = ()=>goBackTo(privateRoutesPath.INVOICE,searchEntity?.invoice);
    
    return (
        <BiztantuLoader open={isLoadingProgress} isChildren={true}>
             <Box className='globalBox'>
                <StyledSubHeader>
                    {/* <Typography variant='h6'>
                        {handleValidateCodevalue(internationalise,'INV_EDIT_TITLE_CREATE')}
                    </Typography> */}
                </StyledSubHeader>
                <StyledSubHeader>
                {handleValidateCodevalue(internationalise,'INV_DETAILS')}
                </StyledSubHeader>
                <StyledGridContainer>
                     <SelectBoxWithLabel
                        ownerdropdown = {false}
                        name="status"
                        label={handleValidateCodevalue(internationalise,'INV_EDIT_STATUS')}
                        disabled= {true}
                        value={invoicedetail?.status}
                        optionMenuItem={invoiceStatusData}
                        isStatic={false}
                    />
                    <AutoCompleteComponent
                        required={true}
                        optionSet = {ownerlistdropdown}
                        value={invoicedetail?.selectedOwner|| null}
                        error={invoicedetail?.selectedOwner ? false : isRequired}
                        name = "ownerId"
                        placeholder={handleValidateCodevalue(internationalise,'INV_EDIT_OWNER')}
                        disabled = {!(specificRolePermission?.isAllInvoiceManage || specificRolePermission?.isInvoiceTeamManage)}
                        label={handleValidateCodevalue(internationalise,'INV_EDIT_OWNER')}
                        onChange={(event, Owner) => handleSelectOwner(event, Owner)}
                    />
                </StyledGridContainer>
                
                <StyledGridContainer>
                <AutoCompleteComponent
                    required={true}
                    isOwner = {true}
                    optionSet = {customerdropdown}
                    value={invoicedetail?.selectedCustomer|| null}
                    error={invoicedetail?.selectedCustomer ? false : isRequired}
                    name = "selectedCustomer"
                    placeholder={handleValidateCodevalue(internationalise,'INV_EDIT_CUSTOMER')}
                    label={handleValidateCodevalue(internationalise,'INV_EDIT_CUSTOMER')}
                    onChange={(event, Customer) => handleSelectCustomer(event, Customer)}
                />
                </StyledGridContainer>
                    <EntityNote
                    entityDetails = {invoicedetail} 
                    onChange = {handleChangeInvoiceDetails}        
                    headingLabel = {handleValidateCodevalue(internationalise,"COMMON_SPECIAL_NOTE")}
                    />
                <LeadProduct
                                    isInvoice={true}
                                    isViewMode = {isViewMode}
                                    productTypes={productStaticType}
                                    data={invoiceProducts}
                                    selectedproductData={selectedproductData}
                                    isOrderproduct= {true}
                                    selectedproduct={selectedproduct}
                                    selectedaddedproduct={selectedaddedproduct}
                                    productQuantity={productQuantity}
                                    handleChangeQuantity={handleChangeQuantity}
                                    getDataGridData={(data) => setTableData(data)}
                                    handleAddLeadProduct={handleAddOrderProduct}
                                    handleUpdateLeadproduct={handleUpdateOrderproduct}
                                    handleSelectMultiproduct={handleSelectMultiproduct}
                                    handleFilterOption={handleFilterOption}
                                    inputprice={inputprice}
                                    invoiceStatus = {invoicedetail?.status}
                                    handleClearAfterAdded={handleClearAfterAdded}
                                    handlegenerateinvoice = {handlegenerateinvoice}
                                    setSelectionModel={(data) => setSelectionModel(data)}
                                    selectionModel={selectionModel}
                                    handleviewinvoices={handleviewproductinvoices} 
                                    accordionLabel = {handleValidateCodevalue(internationalise,'INV_PROD_DETAILS')}
                                />

            </Box>
            <CreateLeadFooter>
                <Stack alignItems="center" display={"flex"} justifyContent={"space-between"} flexDirection={"row"}>
                    <Typography variant='h6'>
                        {handleValidateCodevalue(internationalise,'INV_EDIT_TITLE_CREATE')}
                    </Typography>
                
                <Button className='edit-primary btn-space' variant="outlined" onClick={goBack}>{handleValidateCodevalue(internationalise,'COMMON_BACK')}</Button>
                {!isViewMode && <Button className='edit-primary' variant="outlined" onClick={handleCreateInvoice} >{handleValidateCodevalue(internationalise,'COMMON_SAVE')}</Button>}
                </Stack>
            </CreateLeadFooter>
            
        </BiztantuLoader>
    )
}
export default CreateInvoice
